import type { DashboardTaskCode, DashboardTaskCodeResource } from '~/services/api/generated'
import type { PresentationInstruction } from './PresentationInstruction'
import type { TranslateFn } from './TranslateFn'
import { resolveCode } from './resolveCode'
import { dashboardTaskTitleResolverMap } from './dashboardTaskTitleResolverMap'
import { dashboardTaskDescriptionResolverMap } from './dashboardTaskDescriptionResolverMap'

interface DashboardTaskDisplay {
  title: string
  description: string
}

const openTaskInstruction = (
  taskCode: DashboardTaskCodeResource
): PresentationInstruction<DashboardTaskCode> => {
  const params = taskCode.params
  if (params === undefined) return { code: taskCode.code }

  return {
    code: taskCode.code,
    params: { store_name: params.store_name },
    reason: params.can_submit ? 'ready' : 'incomplete'
  }
}

/** A locked task describes what unlocks it; an open task describes itself. */
export function resolveDashboardTaskDisplay(
  taskCode: DashboardTaskCodeResource,
  isLocked: boolean,
  t: TranslateFn
): DashboardTaskDisplay {
  const instruction: PresentationInstruction<DashboardTaskCode> = isLocked
    ? { code: taskCode.code, reason: 'locked' }
    : openTaskInstruction(taskCode)

  return {
    title: resolveCode({ code: taskCode.code }, dashboardTaskTitleResolverMap, t),
    description: resolveCode(instruction, dashboardTaskDescriptionResolverMap, t)
  }
}
